import moment from "moment";
import React from "react";
import { Badge } from "@themesberg/react-bootstrap";

export const TableRow = (props) => {
  const {
    ClassicResult,
    user,
    ClassicLotteryStorage,
    ClassicCartId,
    ticketId,
    amount,
    status,
    createdAt,
    ClassicLotteryChannel,
  } = props;

  // Trạng thái vé: 1=Đã mua, 2=Đang đợi, 3=Đã xuất vé, 4=Trúng thưởng, 5=Không trúng
  const getStatusInfo = () => {
    switch (status) {
      case 1:
        return { text: "Đã mua", color: "info" };
      case 2:
        return { text: "Đang chụp", color: "warning" };
      case 3:
        return { text: "Đã xuất vé", color: "primary" };
      case 4:
        return { text: "Trúng thưởng", color: "success" };
      case 5:
        return { text: "Không trúng", color: "secondary" };
      default:
        return { text: "Hủy", color: "danger" };
    }
  };
  const statusInfo = getStatusInfo();

  return (
    <>
      <td className="text-center">
        {ClassicLotteryStorage?.images ? (
          <div
            className="rounded overflow-hidden d-inline-block"
            style={{ width: 48, height: 48, cursor: "pointer" }}
            onClick={() => {
              if (props.onPreviewImage) {
                props.onPreviewImage(`Ảnh vé ${ticketId || ""}`, ClassicLotteryStorage.images);
              }
            }}
          >
            <img
              src={ClassicLotteryStorage.images}
              alt="Ticket"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              onError={(e) => {
                e.target.parentElement.style.display = "none";
              }}
            />
          </div>
        ) : (
          <span className="text-muted small">-</span>
        )}
      </td>
      <td>
        {user?.name || ""}
        <br />
        <span>
          <strong className={`text-primary`}>{user?.phone || ""}</strong>
        </span>
      </td>
      <td className="text-center" style={{ fontSize: "0.8rem" }}>
        {ClassicCartId}
      </td>
      <td className="text-center">
        <strong
          className="text-primary"
          style={{ fontSize: "1.1rem", letterSpacing: "2px" }}
        >
          {(ClassicLotteryStorage?.numbers || "").split("").join(" ")}
        </strong>
        <br />
        {ticketId && (
          <small className="text-muted" style={{ fontSize: "0.75rem" }}>
            Mã vé: <span className="text-dark">{ticketId}</span>
          </small>
        )}
        <br />
        <div className="d-flex align-items-center justify-content-center gap-2 mt-1">
          {ClassicLotteryChannel.logo && (
            <img
              src={ClassicLotteryChannel.logo}
              alt={ClassicLotteryChannel.name}
              className="rounded-circle border border-gray-200"
              style={{ width: "20px", height: "20px", objectFit: "cover" }}
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          )}
          <small>
            {ClassicLotteryChannel?.name || ""}{" "}
            {ClassicResult?.resultDate ? `- ${ClassicResult.resultDate}` : ""}
          </small>
        </div>
      </td>
      <td className="text-center">{amount}</td>
      <td className="text-center">
        <Badge bg={statusInfo.color}>{statusInfo.text}</Badge>
      </td>
      <td className="text-center">
        {moment(createdAt || "").format("DD/MM/YYYY HH:mm")}
      </td>
    </>
  );
};
